/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemTaxFull,
  LineItemTaxFullOptional,
  LineItemTaxFullMetaI,
  LineItemTaxFullTrackedI,
} from "./line-item-tax-full";
import {
  LineItemTaxFullTracked,
  LineItemTaxFullMeta,
} from "./line-item-tax-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  TaxRef,
  TaxRefOptional,
  TaxRefMetaI,
  TaxRefTrackedI,
} from "./tax-ref";
import { TaxRefTracked, TaxRefMeta } from "./tax-ref";

/**
 *
 * @export
 * @interface LineItemTaxDTO
 */
export interface LineItemTaxDTOOptional extends LineItemTaxFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof LineItemTaxDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemTaxDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxDTO
   */
  assignId?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxDTO
   */
  unitAmountTaxableCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxDTO
   */
  amountBaseCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxDTO
   */
  amountTotalCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxDTO
   */
  amountPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxDTO
   */
  amountRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxDTO
   */
  amountToRefundCents?: number;
  /**
   *
   * @type {string}
   * @memberof LineItemTaxDTO
   */
  taxRateUsed?: string;
  /**
   *
   * @type {TaxRef}
   * @memberof LineItemTaxDTO
   */
  taxId?: TaxRefOptional;
}

export interface LineItemTaxDTO
  extends LineItemTaxDTOOptional, LineItemTaxFull {
  /**
   *
   * @type {boolean}
   * @memberof LineItemTaxDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemTaxDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxDTO
   */
  assignId: number;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxDTO
   */
  unitAmountTaxableCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxDTO
   */
  amountBaseCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxDTO
   */
  amountTotalCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxDTO
   */
  amountPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxDTO
   */
  amountRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxDTO
   */
  amountToRefundCents?: number;
  /**
   *
   * @type {string}
   * @memberof LineItemTaxDTO
   */
  taxRateUsed?: string;
  /**
   *
   * @type {TaxRef}
   * @memberof LineItemTaxDTO
   */
  taxId: TaxRef;
}

export interface LineItemTaxDTOTrackedI extends LineItemTaxFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof LineItemTaxDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemTaxDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxDTO
   */
  unitAmountTaxableCents?: number;
  unitAmountTaxableCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxDTO
   */
  amountBaseCents?: number;
  amountBaseCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxDTO
   */
  amountTotalCents?: number;
  amountTotalCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxDTO
   */
  amountPaidCents?: number;
  amountPaidCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxDTO
   */
  amountRefundedCents?: number;
  amountRefundedCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemTaxDTO
   */
  amountToRefundCents?: number;
  amountToRefundCentsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof LineItemTaxDTO
   */
  taxRateUsed?: string;
  taxRateUsedIsSet: boolean;
  /**
   *
   * @type {TaxRef}
   * @memberof LineItemTaxDTO
   */
  taxId?: TaxRefTrackedI;
  taxIdIsSet: boolean;
}

transformDatesMap.set("LineItemTaxDTO", function (model: LineItemTaxDTO) {
  const transformDatestaxId = transformDatesMap.get("TaxRef");
  if (transformDatestaxId && model.taxId) {
    transformDatestaxId(model.taxId);
  }
});

export type LineItemTaxDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  unitAmountTaxableCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountBaseCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountPaidCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountRefundedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountToRefundCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  taxRateUsed: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  taxId: PropertyMeta<TaxRefMetaI>;
}>;

export var LineItemTaxDTOMeta: LineItemTaxDTOMetaI = {} as LineItemTaxDTOMetaI;
LineItemTaxDTOMeta = typeMeta("LineItemTaxDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  unitAmountTaxableCents: propertyMeta(
    "unitAmountTaxableCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountBaseCents: propertyMeta(
    "amountBaseCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountTotalCents: propertyMeta(
    "amountTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountPaidCents: propertyMeta(
    "amountPaidCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountRefundedCents: propertyMeta(
    "amountRefundedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountToRefundCents: propertyMeta(
    "amountToRefundCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  taxRateUsed: propertyMeta(
    "taxRateUsed",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  taxId: propertyMeta("taxId", false, true, false, TaxRefMeta),
});

const metaI = LineItemTaxDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([LineItemTaxFullMeta]);
  metaI.isDeleted.inheritedFrom = LineItemTaxFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = LineItemTaxFullMeta.isNew;
  metaI.assignId.inheritedFrom = LineItemTaxFullMeta.assignId;
  metaI.unitAmountTaxableCents.inheritedFrom =
    LineItemTaxFullMeta.unitAmountTaxableCents;
  metaI.amountBaseCents.inheritedFrom = LineItemTaxFullMeta.amountBaseCents;
  metaI.amountTotalCents.inheritedFrom = LineItemTaxFullMeta.amountTotalCents;
  metaI.amountPaidCents.inheritedFrom = LineItemTaxFullMeta.amountPaidCents;
  metaI.amountRefundedCents.inheritedFrom =
    LineItemTaxFullMeta.amountRefundedCents;
  metaI.amountToRefundCents.inheritedFrom =
    LineItemTaxFullMeta.amountToRefundCents;
  metaI.taxRateUsed.inheritedFrom = LineItemTaxFullMeta.taxRateUsed;
  metaI.taxId.inheritedFrom = LineItemTaxFullMeta.taxId;
});

export class LineItemTaxDTOTracked
  extends LineItemTaxFullTracked
  implements LineItemTaxDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  unitAmountTaxableCents__I?: number = undefined;
  unitAmountTaxableCentsIsSet: boolean = false;
  set unitAmountTaxableCents(v: undefined | number) {
    if (v !== undefined) {
      this.unitAmountTaxableCents__I = v;
      this.unitAmountTaxableCentsIsSet = true;
    } else {
      this.unitAmountTaxableCents__I = v || undefined;
      this.unitAmountTaxableCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get unitAmountTaxableCents() {
    return this.unitAmountTaxableCents__I;
  }
  amountBaseCents__I?: number = undefined;
  amountBaseCentsIsSet: boolean = false;
  set amountBaseCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountBaseCents__I = v;
      this.amountBaseCentsIsSet = true;
    } else {
      this.amountBaseCents__I = v || undefined;
      this.amountBaseCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountBaseCents() {
    return this.amountBaseCents__I;
  }
  amountTotalCents__I?: number = undefined;
  amountTotalCentsIsSet: boolean = false;
  set amountTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountTotalCents__I = v;
      this.amountTotalCentsIsSet = true;
    } else {
      this.amountTotalCents__I = v || undefined;
      this.amountTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTotalCents() {
    return this.amountTotalCents__I;
  }
  amountPaidCents__I?: number = undefined;
  amountPaidCentsIsSet: boolean = false;
  set amountPaidCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountPaidCents__I = v;
      this.amountPaidCentsIsSet = true;
    } else {
      this.amountPaidCents__I = v || undefined;
      this.amountPaidCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountPaidCents() {
    return this.amountPaidCents__I;
  }
  amountRefundedCents__I?: number = undefined;
  amountRefundedCentsIsSet: boolean = false;
  set amountRefundedCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountRefundedCents__I = v;
      this.amountRefundedCentsIsSet = true;
    } else {
      this.amountRefundedCents__I = v || undefined;
      this.amountRefundedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountRefundedCents() {
    return this.amountRefundedCents__I;
  }
  amountToRefundCents__I?: number = undefined;
  amountToRefundCentsIsSet: boolean = false;
  set amountToRefundCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountToRefundCents__I = v;
      this.amountToRefundCentsIsSet = true;
    } else {
      this.amountToRefundCents__I = v || undefined;
      this.amountToRefundCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountToRefundCents() {
    return this.amountToRefundCents__I;
  }
  taxRateUsed__I?: string = undefined;
  taxRateUsedIsSet: boolean = false;
  set taxRateUsed(v: undefined | string) {
    if (v !== undefined) {
      this.taxRateUsed__I = v;
      this.taxRateUsedIsSet = true;
    } else {
      this.taxRateUsed__I = v || undefined;
      this.taxRateUsedIsSet = false;
    }
    this.changeTracker = true;
  }
  get taxRateUsed() {
    return this.taxRateUsed__I;
  }
  taxId__I?: TaxRefTracked = undefined;
  taxIdIsSet: boolean = false;
  set taxId(v: undefined | TaxRefTracked) {
    if (v !== undefined) {
      this.taxId__I = v;
      this.taxIdIsSet = true;
    } else {
      this.taxId__I = v || undefined;
      this.taxIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get taxId() {
    return this.taxId__I;
  }
  constructor(config?: LineItemTaxDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.taxId?.setIds();
  }
  assignFrom(
    config: LineItemTaxDTOOptional,
    options?: AssignOptions,
  ): LineItemTaxDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.unitAmountTaxableCents &&
      this.unitAmountTaxableCentsApplyFilter(optionsRequired.filter)
    ) {
      this.unitAmountTaxableCents = config.unitAmountTaxableCents;
      if (optionsRequired.unassign) this.unitAmountTaxableCentsIsSet = false;
      else this.unitAmountTaxableCentsIsSet = true;
    }
    if (
      config.amountBaseCents &&
      this.amountBaseCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountBaseCents = config.amountBaseCents;
      if (optionsRequired.unassign) this.amountBaseCentsIsSet = false;
      else this.amountBaseCentsIsSet = true;
    }
    if (
      config.amountTotalCents &&
      this.amountTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountTotalCents = config.amountTotalCents;
      if (optionsRequired.unassign) this.amountTotalCentsIsSet = false;
      else this.amountTotalCentsIsSet = true;
    }
    if (
      config.amountPaidCents &&
      this.amountPaidCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountPaidCents = config.amountPaidCents;
      if (optionsRequired.unassign) this.amountPaidCentsIsSet = false;
      else this.amountPaidCentsIsSet = true;
    }
    if (
      config.amountRefundedCents &&
      this.amountRefundedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountRefundedCents = config.amountRefundedCents;
      if (optionsRequired.unassign) this.amountRefundedCentsIsSet = false;
      else this.amountRefundedCentsIsSet = true;
    }
    if (
      config.amountToRefundCents &&
      this.amountToRefundCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountToRefundCents = config.amountToRefundCents;
      if (optionsRequired.unassign) this.amountToRefundCentsIsSet = false;
      else this.amountToRefundCentsIsSet = true;
    }
    if (
      config.taxRateUsed &&
      this.taxRateUsedApplyFilter(optionsRequired.filter)
    ) {
      this.taxRateUsed = config.taxRateUsed;
      if (optionsRequired.unassign) this.taxRateUsedIsSet = false;
      else this.taxRateUsedIsSet = true;
    }
    if (config.taxId && this.taxIdApplyFilter(optionsRequired.filter)) {
      this.taxId = new TaxRefTracked(config.taxId, options);
      if (optionsRequired.unassign) this.taxIdIsSet = false;
      else this.taxIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): LineItemTaxDTOTrackedI {
    const cloned = {} as LineItemTaxDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.unitAmountTaxableCentsIsSetDeep() &&
      this.unitAmountTaxableCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.unitAmountTaxableCentsIsSet = true;
      cloned.unitAmountTaxableCents = this.unitAmountTaxableCents;
    } else {
      //cloned.unitAmountTaxableCentsIsSet = false
    }
    if (
      this.amountBaseCentsIsSetDeep() &&
      this.amountBaseCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountBaseCentsIsSet = true;
      cloned.amountBaseCents = this.amountBaseCents;
    } else {
      //cloned.amountBaseCentsIsSet = false
    }
    if (
      this.amountTotalCentsIsSetDeep() &&
      this.amountTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTotalCentsIsSet = true;
      cloned.amountTotalCents = this.amountTotalCents;
    } else {
      //cloned.amountTotalCentsIsSet = false
    }
    if (
      this.amountPaidCentsIsSetDeep() &&
      this.amountPaidCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountPaidCentsIsSet = true;
      cloned.amountPaidCents = this.amountPaidCents;
    } else {
      //cloned.amountPaidCentsIsSet = false
    }
    if (
      this.amountRefundedCentsIsSetDeep() &&
      this.amountRefundedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountRefundedCentsIsSet = true;
      cloned.amountRefundedCents = this.amountRefundedCents;
    } else {
      //cloned.amountRefundedCentsIsSet = false
    }
    if (
      this.amountToRefundCentsIsSetDeep() &&
      this.amountToRefundCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountToRefundCentsIsSet = true;
      cloned.amountToRefundCents = this.amountToRefundCents;
    } else {
      //cloned.amountToRefundCentsIsSet = false
    }
    if (
      this.taxRateUsedIsSetDeep() &&
      this.taxRateUsedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.taxRateUsedIsSet = true;
      cloned.taxRateUsed = this.taxRateUsed;
    } else {
      //cloned.taxRateUsedIsSet = false
    }
    if (
      this.taxIdIsSetDeep() &&
      this.taxIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.taxIdIsSet = true;
      cloned.taxId = this.taxId?.removeUnset(filter);
    } else {
      //cloned.taxIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): LineItemTaxDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.unitAmountTaxableCentsApplyFilter(filter))
      this.unitAmountTaxableCentsIsSet = false;

    if (!this.amountBaseCentsApplyFilter(filter))
      this.amountBaseCentsIsSet = false;

    if (!this.amountTotalCentsApplyFilter(filter))
      this.amountTotalCentsIsSet = false;

    if (!this.amountPaidCentsApplyFilter(filter))
      this.amountPaidCentsIsSet = false;

    if (!this.amountRefundedCentsApplyFilter(filter))
      this.amountRefundedCentsIsSet = false;

    if (!this.amountToRefundCentsApplyFilter(filter))
      this.amountToRefundCentsIsSet = false;

    if (!this.taxRateUsedApplyFilter(filter)) this.taxRateUsedIsSet = false;

    if (!this.taxIdApplyFilter(filter)) this.taxIdIsSet = false;
    this.taxId?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemTaxDTOMeta.isDeleted,
      LineItemTaxDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemTaxDTOMeta.isNew,
      LineItemTaxDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemTaxDTOMeta.assignId,
      LineItemTaxDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  unitAmountTaxableCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemTaxDTOMeta.unitAmountTaxableCents,
      LineItemTaxDTOMeta,
      this.unitAmountTaxableCents,
      this,
    );
  }
  unitAmountTaxableCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.unitAmountTaxableCentsIsSet &&
      this.unitAmountTaxableCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountBaseCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemTaxDTOMeta.amountBaseCents,
      LineItemTaxDTOMeta,
      this.amountBaseCents,
      this,
    );
  }
  amountBaseCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountBaseCentsIsSet && this.amountBaseCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemTaxDTOMeta.amountTotalCents,
      LineItemTaxDTOMeta,
      this.amountTotalCents,
      this,
    );
  }
  amountTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountTotalCentsIsSet && this.amountTotalCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountPaidCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemTaxDTOMeta.amountPaidCents,
      LineItemTaxDTOMeta,
      this.amountPaidCents,
      this,
    );
  }
  amountPaidCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountPaidCentsIsSet && this.amountPaidCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountRefundedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemTaxDTOMeta.amountRefundedCents,
      LineItemTaxDTOMeta,
      this.amountRefundedCents,
      this,
    );
  }
  amountRefundedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountRefundedCentsIsSet &&
      this.amountRefundedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountToRefundCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemTaxDTOMeta.amountToRefundCents,
      LineItemTaxDTOMeta,
      this.amountToRefundCents,
      this,
    );
  }
  amountToRefundCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountToRefundCentsIsSet &&
      this.amountToRefundCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  taxRateUsedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemTaxDTOMeta.taxRateUsed,
      LineItemTaxDTOMeta,
      this.taxRateUsed,
      this,
    );
  }
  taxRateUsedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.taxRateUsedIsSet && this.taxRateUsedApplyFilter(filter))
      return true;

    return false;
  }
  taxIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemTaxDTOMeta.taxId,
      LineItemTaxDTOMeta,
      this.taxId,
      this,
    );
  }
  taxIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.taxIdIsSet && this.taxIdApplyFilter(filter)) return true;
    return this.taxId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.unitAmountTaxableCentsIsSetDeep(filter)) return true;
    if (this.amountBaseCentsIsSetDeep(filter)) return true;
    if (this.amountTotalCentsIsSetDeep(filter)) return true;
    if (this.amountPaidCentsIsSetDeep(filter)) return true;
    if (this.amountRefundedCentsIsSetDeep(filter)) return true;
    if (this.amountToRefundCentsIsSetDeep(filter)) return true;
    if (this.taxRateUsedIsSetDeep(filter)) return true;
    if (this.taxIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
